import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./pre_calculation.module.css";
import ImportORModal from "./ImportORModal";

const PreCalculation = () => {
  const navigate = useNavigate();
  const [showImport, setShowImport] = useState(false);

  return (
    <>
      <h1 style={{ color: "#fff", textAlign: "center", maxWidth: 600, margin: "0 auto 20px" }}>
        Cálculo Precatório
      </h1>

      <div className={styles.formContainer} style={{ textAlign: "center" }}>
        <p className={styles.chooserTitle}>Como você quer enviar os dados?</p>

        <div className={styles.chooserActions}>
          <button
            type="button"
            className={styles.chooserButton}
            onClick={() => navigate("/home/calculation/manual")}
          >
            Inserir manualmente
          </button>

          <button
            type="button"
            className={styles.chooserButton}
            onClick={() => setShowImport(true)}
          >
            Importar OR (PDF)
          </button>
        </div>
      </div>

      <ImportORModal
        open={showImport}
        onClose={() => setShowImport(false)}
        onUseData={(prefill) => {
          setShowImport(false);
          // manda o prefill via state para o formulário
          navigate("/home/calculation/manual", { state: { prefill } });
        }}
      />
    </>
  );
};

export default PreCalculation;
